<template>
    <div class="tradingview-widget-container tape">
        <div class="tradingview-widget-container__widget"></div>
    </div>
</template>

<script>
export default {
    name:'TradingViewTape',
    props:['darkTheme'],
    watch:{
        darkTheme(){
            this.createChart();
        },
    },
    methods:{
        createChart(){
            document.querySelector('.tradingview-widget-container').innerHTML = '<div class="tradingview-widget-container__widget"></div>';
            let externalScript = document.createElement('script')
            externalScript.setAttribute('src', 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js');
            let theme = this.darkTheme ? "dark" : 'light';
            externalScript.textContent = `{
            "symbols": [
                {
                "proName": "FOREXCOM:SPXUSD",
                "title": "S&P 500"
                },
                {
                "proName": "FOREXCOM:NSXUSD",
                "title": "Nasdaq 100"
                },
                {
                "proName": "FX_IDC:EURUSD",
                "title": "EUR/USD"
                },
                {
                "proName": "BITSTAMP:BTCUSD",
                "title": "BTC/USD"
                },
                {
                "proName": "BITSTAMP:ETHUSD",
                "title": "ETH/USD"
                }
            ],
            "locale": "en",
            "colorTheme": "${theme}",
            "isTransparent": true
            }`;
            document.querySelector('.tradingview-widget-container').appendChild(externalScript);
        }
    },
    mounted(){
        this.createChart();
    }
}
</script>

<style lang="scss">
.tape{
    width: calc(100% - 370px) !important;
    overflow: hidden;
    pointer-events: none;
    iframe{
        width: calc(100% + 100px) !important;
    }
    @media (max-width: 650px) {
        width: calc(100% - 90px) !important;
    }
}
</style>